import logo from './assets/images/logo_gsm.png';
import carrito from './assets/images/carrito.png';
import eliminar from './assets/images/eliminar.png';
import perfil from './assets/images/perfil.png';
import hero from './assets/images/hero.png';
import categorias from './assets/images/bg_categorias.png';
import telefono from './assets/images/telefono.png';
import flechaBoton from './assets/images/flecha_boton.png';
import estrellaLlena from './assets/images/estrella_llena.png';
import estrellaVacia from './assets/images/estrella_vacia.png';
import agregarProducto from './assets/images/añadir_producto.png';
import whatsapp from './assets/images/whatsapp.png';
import filtros from './assets/images/filtros.png';
import ubicacion from './assets/images/ubicacion.png';
import mail from './assets/images/mail.png';
import intraud from './assets/images/intraud.png';
import indura from './assets/images/indura.png';
import argentec from './assets/images/argentec.png';
import conarco from './assets/images/conarco.png';
import subrayado from './assets/images/subrayado.png';
import flecha from './assets/images/flecha.png';
import sierra from './assets/images/categorias/sierra.png';
import soldadora from './assets/images/categorias/soldadora.png';
import auxiliares from './assets/images/categorias/auxiliares_soldadora.png';

const images = {
  logos: {
    logo,
    marcas:{
      indura,
      intraud,
      argentec,
      conarco,
      indura,
      intraud,
      argentec,
      conarco,
      indura,
      intraud,
      argentec,
      conarco
    }
  },
  icons: {
    carrito,
    perfil,
    telefono,
    whatsapp,
    flecha,
    mail,
    ubicacion,
    estrellaLlena,
    estrellaVacia,
    agregarProducto,
    flechaBoton,
    filtros,
    eliminar
  },
  backgrounds: {
    hero,
    categorias
  },
  otros:{
    subrayado
  },
  categorias:{
    sierra,
    auxiliares,
    soldadora
  }
};
export default images;